import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useDefaultSite } from '@/hooks/useDefaultSite';

interface BillingCenterSelectProps {
  value: string | null;
  onChange: (siteId: string) => void;
  disabled?: boolean;
}

export function BillingCenterSelect({
  value,
  onChange,
  disabled = false,
}: BillingCenterSelectProps) {
  const { organization, isLoading, isError } = useDefaultSite();
  const sites = organization?.sites ?? [];

  return (
    <Select
      value={value ?? undefined}
      onValueChange={onChange}
      disabled={disabled || isLoading || isError}
    >
      <SelectTrigger className="h-10 w-full bg-white">
        <SelectValue
          placeholder={
            isLoading
              ? 'Chargement...'
              : 'Sélectionnez un centre de facturation'
          }
        />
      </SelectTrigger>
      <SelectContent>
        {sites.length === 0 && (
          <div className="px-4 py-3 text-sm text-slate-500">
            Aucun centre de facturation disponible
          </div>
        )}
        {sites.map((site) => (
          <SelectItem key={site.id} value={site.id}>
            {site.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
